import { LoadRecentOrdersUsecase, LoadRecentOrdersUsecaseImp } from 'domain/usecases/load-recent-orders-usecase';
import { makeLoadRecentOrdersRepository } from '../repositories/http/orders-http-repository-factory';

export const makeLoadRecentOrdersUsecase = (): LoadRecentOrdersUsecase => {
  return new LoadRecentOrdersUsecaseImp(makeLoadRecentOrdersRepository());
};
